(function () {
  const selectors = {
    notification: 'cart-notification',
    panel: '#cart-notification',
    form: '#cart-notification-form',
    checkoutButton: '#cart-notification-form button[name="checkout"]',
    checkbox: '[data-cart-notification-consent-checkbox]',
    error: '[data-cart-notification-consent-error]'
  };

  const consentVersion = 'digital-access-waiver-test-2026-06-11';
  let consentReady = false;
  let consentSavePending = false;

  function getElements() {
    const notification = document.querySelector(selectors.notification);

    return {
      notification,
      panel: document.querySelector(selectors.panel),
      form: document.querySelector(selectors.form),
      checkoutButton: document.querySelector(selectors.checkoutButton),
      checkbox: notification ? notification.querySelector(selectors.checkbox) : null,
      error: notification ? notification.querySelector(selectors.error) : null
    };
  }

  function setError(message) {
    const { error } = getElements();
    if (!error) return;

    error.textContent = message || 'Please confirm immediate digital access before checkout.';
    error.hidden = !message;
  }

  function setCheckoutState(enabled, busy) {
    const { checkoutButton } = getElements();
    if (!checkoutButton) return;

    checkoutButton.disabled = !enabled;

    if (busy) {
      checkoutButton.setAttribute('aria-busy', 'true');
    } else {
      checkoutButton.removeAttribute('aria-busy');
    }
  }

  function resetConsent() {
    const { checkbox } = getElements();

    consentReady = false;
    consentSavePending = false;

    if (checkbox) {
      checkbox.checked = false;
    }

    setCheckoutState(false, false);
    setError('');
  }

  function saveConsent() {
    const acceptedAt = new Date().toISOString();
    const body = JSON.stringify({
      attributes: {
        digital_access_waiver_accepted: 'true',
        digital_access_waiver_accepted_at: acceptedAt,
        digital_access_waiver_source: 'cart_notification',
        digital_access_waiver_version: consentVersion
      }
    });

    consentReady = false;
    consentSavePending = true;
    setCheckoutState(false, true);
    setError('');

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) throw new Error('Consent could not be saved.');
        return response.json();
      })
      .then(() => {
        consentReady = true;
        consentSavePending = false;
        setCheckoutState(true, false);
      })
      .catch(() => {
        const { checkbox } = getElements();

        consentReady = false;
        consentSavePending = false;

        if (checkbox) {
          checkbox.checked = false;
        }

        setCheckoutState(false, false);
        setError('Consent could not be saved. Please try again.');
      });
  }

  function handleChange(event) {
    if (!event.target.matches(selectors.checkbox)) return;

    if (!event.target.checked) {
      resetConsent();
      return;
    }

    saveConsent();
  }

  function handleSubmit(event) {
    const { checkbox } = getElements();

    if (!event.target.matches(selectors.form)) return;
    if (consentReady && !consentSavePending) return;

    event.preventDefault();

    if (!consentSavePending) {
      setError('Please confirm immediate digital access before checkout.');
    }

    if (checkbox) {
      checkbox.focus();
    }
  }

  function observeNotification() {
    const { panel } = getElements();
    if (!panel) return;

    const observer = new MutationObserver(() => {
      if (panel.classList.contains('active')) {
        resetConsent();
      }
    });

    observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    setCheckoutState(false, false);
    document.addEventListener('change', handleChange);
    document.addEventListener('submit', handleSubmit);
    observeNotification();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
